import format from './format'

const color = ['#FF5F4C', '#FFAB45', '#32C1FF', '#FFD300', '#17CE74', '#8E83E7', '#578EEF']
const bagColor = ['#e3f9fd', '#fcefe8', '#f2ecde', '#e0f0e9', '#e3f9fd', '#fcefe8']
// 雷达图
const getRadarOption = (dataSeries) => {
  const names = []
  const indicator = [
    {
      text: '被动行为',
      min: 0,
      axisLabel: { show: true }
    },
    {
      text: '主动行为',
      axisLabel: { show: true },
      min: 0
    },
    {
      text: '构建行为',
      axisLabel: { show: true },
      min: 0
    },
    {
      text: '交互行为',
      axisLabel: { show: true },
      min: 0
    }
  ]
  for (let i = 0; i < dataSeries.length; i++) {
    names.push(dataSeries[i].name)
    dataSeries[i].value[0] = (dataSeries[i].value[0] / 3600).toFixed(1) // 秒转小时处理
  }

  const radarOption = {
    color: color,
    backgroundColor: '#fff',
    legend: {
      show: true,
      // icon: 'circle',//图例形状
      overflow: 'none',
      top: 0,
      left: 0,
      center: 20,
      itemWidth: 14, // 图例标记的图形宽度。[ default: 25 ]
      itemHeight: 14, // 图例标记的图形高度。[ default: 14 ]
      itemGap: 21, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
      textStyle: {
        fontSize: 14,
        color: '#000'
      },
      formatter: (name) => {
        if (!name) return ''
        return lineFeedLabel(name, 8) // 根据你的需求修改参数
      },
      data: names
    },
    grid: {
      left: '0%',
      right: '0%',
      bottom: '10%',
      top: '10%',
      containLabel: true
    },
    tooltip: {
      show: true,
      trigger: 'item',
      formatter: function (params) {
        // params 是包含数据信息的对象
        //  console.log(params)
        var value = params.value
        var tooltipContent = ''
        var colorSpan = '<span style="display:inline-block;margin-right:5px;width:10px;height:10px;border-radius:50%;background-color:' + params.color + '"></span>'
        for (var i = 0; i < indicator.length; i++) {
          var unit = '次'
          if (i === 0) {
            unit = '小时'
          }
          tooltipContent += indicator[i].text + ': ' + value[i] + unit + '<br/>'
        }
        var title = params.name.length > 6 ? params.name.slice(0, 6) + '...' : params.name
        return colorSpan + title + '<br/>' + tooltipContent
      }
    },
    radar: [
      {
        indicator: indicator,
        textStyle: {
          color: 'red'
        },
        center: ['50%', '55%'],
        // radius: 142,
        // startAngle: 0,
        // splitNumber: 5,
        // 图例列表的布局朝向,默认'horizontal'为横向,'vertical'为纵向.
        orient: 'horizontal',
        name: {
          formatter: '{value}',
          textStyle: {
            fontSize: 14, // 外圈标签字体大小
            color: '#000' // 外圈标签字体颜色
          }
        },
        splitArea: {
          // 坐标轴在 grid 区域中的分隔区域，默认不显示。
          show: true,
          areaStyle: {
            // 分隔区域的样式设置
            // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
            color: ['rgba(250, 250, 250, 0.2)', 'rgba(238, 238, 238, 1)']
          }
        },
        axisLabel: {
          // 展示刻度
          show: true
        },
        axisLine: {
          // 指向外圈文本的分隔线样式
          lineStyle: {
            color: 'rgba(187, 187, 187, 1)'
          }
        },
        splitLine: {
          lineStyle: {
            color: 'rgba(204, 204, 204, 1)', // 分隔线颜色
            width: 1 // 分隔线线宽
          }
        }
      }
    ],
    series: [
      {
        name: '雷达图',
        type: 'radar',
        itemStyle: {
          emphasis: {
            lineStyle: {
              width: 5
            }
          }
        },
        data: dataSeries
      }
    ]
  }
  return radarOption
}

// 首页雷达图
const getHomeRadarOption = (dataSeries) => {
  const indicator = [
    {
      text: '被动行为',
      min: 0,
      axisLabel: { show: true }
    },
    {
      text: '主动行为',
      axisLabel: { show: true },
      min: 0
    },
    {
      text: '构建行为',
      axisLabel: { show: true },
      min: 0
    },
    {
      text: '交互行为',
      axisLabel: { show: true },
      min: 0
    }
  ]
  for (let i = 0; i < dataSeries.length; i++) {
    dataSeries[i].value[0] = (dataSeries[i].value[0] / 3600).toFixed(1) // 秒转小时处理
  }
  const radarOption = {
    color: color,
    backgroundColor: '#fff',
    grid: {
      left: '0%',
      right: '0%',
      bottom: '40%',
      top: '10%',
      containLabel: true
    },
    tooltip: {
      show: true,
      trigger: 'item',
      formatter: function (params) {
        // params 是包含数据信息的对象
        //  console.log(params)
        var value = params.value
        var tooltipContent = ''
        var colorSpan = '<span style="display:inline-block;margin-right:5px;width:10px;height:10px;border-radius:50%;background-color:' + params.color + '"></span>'
        for (var i = 0; i < indicator.length; i++) {
          var unit = '次'
          if (i === 0) {
            unit = '小时'
          }
          tooltipContent += indicator[i].text + ': ' + value[i] + unit + '<br/>'
        }
        var title = params.name.length > 6 ? params.name.slice(0, 6) + '...' : params.name
        return colorSpan + title + '<br/>' + tooltipContent
      }
    },
    radar: [
      {
        indicator: indicator,
        textStyle: {
          color: 'red'
        },
        center: ['50%', '55%'],
        // radius: 142,
        // startAngle: 0,
        // splitNumber: 5,
        // 图例列表的布局朝向,默认'horizontal'为横向,'vertical'为纵向.
        orient: 'horizontal',
        name: {
          formatter: '{value}',
          textStyle: {
            fontSize: 14, // 外圈标签字体大小
            color: '#000' // 外圈标签字体颜色
          }
        },
        splitArea: {
          // 坐标轴在 grid 区域中的分隔区域，默认不显示。
          show: true,
          areaStyle: {
            // 分隔区域的样式设置
            // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
            color: ['rgba(250, 250, 250, 0.2)', 'rgba(238, 238, 238, 1)']
          }
        },
        axisLabel: {
          // 展示刻度
          show: true
        },
        axisLine: {
          // 指向外圈文本的分隔线样式
          lineStyle: {
            color: 'rgba(187, 187, 187, 1)'
          }
        },
        splitLine: {
          lineStyle: {
            color: 'rgba(204, 204, 204, 1)', // 分隔线颜色
            width: 1 // 分隔线线宽
          }
        }
      }
    ],
    title: { // 添加标题
      text: dataSeries[0].displayName + '的班级表现' || '', // 标题文本
      left: 'center', // 标题位置
      textStyle: {
        fontSize: 14, // 标题字体大小
      }
    },
    series: [
      {
        name: '雷达图',
        type: 'radar',
        itemStyle: {
          emphasis: {
            lineStyle: {
              width: 5
            }
          }
        },
        data: dataSeries
      }
    ]
  }
  return radarOption
}

// 关系图
const getGraphOption = (data) => {
  var nodes = data.nodes
  var links = data.links
  var categories = data.categories
  nodes = nodes.map(item => ({
    ...item // 复制当前对象的所有字段
    // symbolSize: [80, 80],
    // draggable: true,
  }))
  links = links.map(item => ({
    ...item // 复制当前对象的所有字段
    // category: 'A' // 添加新的 category 字段
  }))

  // 指定图表的配置项和数据
  const option = {
    color: color,
    tooltip: {
      formatter: function (params) {
        if (params.dataType === 'edge') {
          const sn = nodes.find((o) => o.id === params.data.source)
          const tn = nodes.find((o) => o.id === params.data.target)
          const p = params.value.split(',')
          return `<div>${sn.name}>${tn.name}<br><b>评论 ${p[0]} 次</b><br>点赞 ${p[1]} 次</div>`
        }
        // return param.data.category + ': ' + param.data.name;
        return params.data.source
      }
    },
    legend: {
      top: '5%',
      data: categories.map(function (a) {
        return a.name || ''
      })
    },
    series: [
      {
        name: '关系图',
        type: 'graph',
        layout: 'force',
        focusNodeAdjacency: true,
        data: nodes,
        links: links,
        categories: categories,
        roam: true,
        label: {
          show: true,
          position: 'right',
          formatter: '{b}',
          fontWeight: 'bolder'
        },
        labelLayout: {
          hideOverlap: true
        },
        scaleLimit: {
          min: 6,
          max: 12
        },
        lineStyle: {
          color: 'source',
          width: 2,
          curveness: 0.3
        }
      }
    ]
  }
  return option
}

// 柱状图--学生画像
const getDrawOption = (data, className, isRead) => {
  // isRead:true代表被动行为，图例显示单位为小时；false代表其他，单位显示为次
  const dataValue = data[0].value
  const series = []
  const names = []
  for (let i = 0; i < data.length; i++) {
    const obj = {
      name: data[i].key,
      type: 'bar',
      barGap: 0,
      barWidth: 40, // 柱图宽度
      emphasis: {
        focus: 'series'
      },
      data: data[i].value
    }
    names.push(data[i].key)
    series.push(obj)
  }

  var defaultShowNum = 3
  const option = {
    color: color,
    dataZoom: [
      {
        type: 'slider', // 缩放条类型为滑动条
        show: dataValue.length > defaultShowNum, // 显示缩放条
        start: 0, // 根据数据计算的开始位置
        end: Math.min(defaultShowNum, dataValue.length) / dataValue.length * 100, // 根据数据计算的结束位置
        bottom: 0, // 距离底部的距离
        height: 4, // 设置高度
        showDetail: false// 是否显示detail，即拖拽时候显示详细数值信息
        // 设置背景颜色
        // backgroundColor: "rgb(19, 63, 100)",
        // 设置选中范围的填充颜色
        // fillerColor: "rgb(16, 171, 198)",
        // 设置边框颜色
        // borderColor: "rgb(19, 63, 100)",
      },
      {
        type: 'inside', // 内置缩放条
        start: 0,
        end: Math.min(defaultShowNum, dataValue.length) / dataValue.length * 100,
        zoomOnMouseWheel: false, // 关闭滚轮缩放
        moveOnMouseWheel: true, // 开启滚轮平移
        moveOnMouseMove: true // 鼠标移动能触发数据窗口平移
      }
    ],
    grid: {
      left: '1%',
      right: '1%',
      bottom: '5%',
      top: '30%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      // 使用 formatter 函数自定义显示的内容
      formatter: function (params) {
        var unit = '次'
        // 显示的内容
        var content = params[0].name.length > 6 ? params[0].name.slice(0, 6) + '...' + '<br/>' : params[0].name + '<br/>'
        // 遍历数据项，构建显示内容
        params.forEach(function (item) {
          var colorSpan = '<span style="display:inline-block;margin-right:5px;width:10px;height:10px;border-radius:50%;background-color:' + item.color + '"></span>'
          if (!isRead) {
            content += colorSpan + item.seriesName + ' : ' + item.value + unit + '<br/>'
          } else {
            content += colorSpan + item.seriesName + ' : ' + format.formattedTime(item.value * 3600) + '<br/>'
          }
        })
        return content
      }
    },
    toolbox: {
      show: false,
      orient: 'vertical',
      left: 'right',
      top: 'center',
      feature: {
        mark: { show: true },
        dataView: { show: true, readOnly: false },
        magicType: { show: true, type: ['line', 'bar', 'stack'] },
        restore: { show: true },
        saveAsImage: { show: true }
      }
    },
    legend: {
      data: names
    },
    xAxis: [
      {
        type: 'category',
        // 不显示坐标轴刻度线
        axisTick: { show: false },
        data: className,
        axisLabel: {
          // 使用formatter函数来格式化标签文字
          formatter: function (value) {
            // 截取前6个字并返回
            return value.length > 16 ? value.slice(0, 16) + '...' : value
          }
        }
      }
    ],
    yAxis: [
      {
        type: 'value'
      }
    ],
    series: series
  }
  return option
}

// 多组柱状图--课程对比
const getCompareOption = (data, styleNames, className, isRead) => {
  // isRead:true代表被动行为，图例显示单位为小时；false代表其他，单位显示为次
  var defaultShowNum = 6
  var newArray = []
  var newArrayName = []
  var newArrayColor = []
  // 循环数组 a 中的每个元素
  for (var i = 0; i < styleNames.length; i++) {
    for (var j = 0; j < className.length; j++) {
      newArray.push(styleNames[i])
      newArrayColor.push(bagColor[i])
      newArrayName.push(className[j])
    }
  }
  const dataValue = data[0].value
  const series = []
  for (let i = 0; i < data.length; i++) {
    const obj = {
      name: data[i].key,
      type: 'bar',
      // barWidth: '30%', // 设置宽度为类目宽度的50%
      barWidth: 40, // 柱图宽度
      emphasis: {
        focus: 'series'
      },
      stack: 'x',
      itemStyle: {
        normal: {
          label: {
            show: i == 0, // 开启显示
            position: 'inside', // 内部显示
            formatter: function (params) {
              var value = newArrayName[params.dataIndex]
              return value.length > 5 ? value.slice(0, 5) + '...' : value
            },
            textStyle: {
              // 数值样式
              color: 'black',
              fontSize: 12
            }
          }
        }
      },
      data: data[i].value
    }
    series.push(obj)
  }
  console.log('series', series)
  console.log('data', data)
  const option = {
    color: color,
    dataZoom: [
      {
        type: 'slider', // 缩放条类型为滑动条
        show: dataValue.length > defaultShowNum, // 显示缩放条
        start: 0, // 根据数据计算的开始位置
        end: Math.min(defaultShowNum, dataValue.length) / dataValue.length * 100, // 根据数据计算的结束位置
        bottom: 0, // 距离底部的距离
        height: 4, // 设置高度
        showDetail: false// 是否显示detail，即拖拽时候显示详细数值信息
      },
      {
        type: 'inside', // 内置缩放条
        start: 0,
        end: Math.min(defaultShowNum, dataValue.length) / dataValue.length * 100,
        zoomOnMouseWheel: false, // 关闭滚轮缩放
        moveOnMouseWheel: true, // 开启滚轮平移
        moveOnMouseMove: true // 鼠标移动能触发数据窗口平移
      }
    ],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      formatter: function (params) {
        var content = params[0].name + '<br/>'
        // 遍历数据项，构建显示内容
        params.forEach(function (item) {
          var colorSpan = '<span style="display:inline-block;margin-right:5px;width:10px;height:10px;border-radius:50%;background-color:' + item.color + '"></span>'
          if (!isRead) {
            content += colorSpan + item.seriesName + ' : ' + item.value + '次<br/>'
          } else {
            content += colorSpan + item.seriesName + ' : ' + format.formattedTime(item.value * 3600) + '<br/>'
          }
        })
        return content
      }
    },
    legend: {},
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: newArray,
        splitArea: {
          show: true,
          // 柱图背景色
          areaStyle: {
            color: newArrayColor
          }
        }
      }
    ],
    yAxis: [
      {
        type: 'value'
      }
    ],
    axisLabel: {
      formatter: function (value) {
        return value.length > 5 ? value.slice(0, 7) + '...' : value
      },
      overflow: 'truncate',
      interval: 0
    },
    series: series
  }
  return option
}

const lineFeedLabel = (data, length) => {
  // data 要处理的字符串
  // length 每行显示长度
  let word = ''
  const num = Math.ceil(data.length / length) // 向上取整数
  // 一行展示length个
  if (num > 1) {
    for (let i = 1; i <= num; i++) {
      word += data.substr((i - 1) * length, length)
      if (i < num) {
        word += '\n'
      }
    }
  } else {
    word += data.substr(0, length)
  }
  return word
}

export {
  getHomeRadarOption,
  getRadarOption,
  getGraphOption,
  getDrawOption,
  getCompareOption
}
